<template>
    <!-- Sidebar -->
    <div id="sidebar-wrapper">
        <ul class="sidebar-nav nav-pills nav-stacked" id="menu">
            <li class="active">
                <router-link v-bind:to="{name: 'HelloWorld'}"><span class="fa-stack fa-lg pull-left"><i class="fa fa-clock-o fa-stack-1x "></i></span>Dashboard</router-link>
            </li>
            <li>
                <label class="tree-toggle nav-header"> <span class="fa-stack fa-lg pull-left"> <i class="fa fa-map-marker fa-stack-1x "></i></span> UI Elements <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                <ul class="nav nav-list tree">
                    <li><router-link v-bind:to="{name: 'ColorChart'}">Color Chart</router-link></li>
                    <li><router-link v-bind:to="{name: 'ContactGrid'}">Contact Grid</router-link></li>
                    <li><router-link v-bind:to="{name: 'Buttons'}">Buttons</router-link></li>
                    <li><router-link v-bind:to="{name: 'Profile'}">Profile</router-link></li>
                    <li><router-link v-bind:to="{name: 'Typography'}">Typography</router-link></li>
                    <li><router-link v-bind:to="{name: 'TooltipAndPopover'}">Tooltip & Popover</router-link></li>
                    <li><router-link v-bind:to="{name: 'Tabs'}">Tabs</router-link></li>
                    <li><router-link v-bind:to="{name: 'Cards'}">Cards</router-link></li>
                    <li><router-link v-bind:to="{name: 'Modals'}">Modals</router-link></li>
                    <li><router-link v-bind:to="{name: 'SweetAlert'}">Alert</router-link></li>
                    <li><router-link v-bind:to="{name: 'Timeline'}">Timeline</router-link></li>
                    <li><router-link v-bind:to="{name: 'Notifications'}">Notifications</router-link></li>
                    <li><a href="#">Progressbar</a></li>
                    <li><a href="#">Breadcrumb</a></li>
                    <li><router-link v-bind:to="{name: 'ListGroup'}">List Group</router-link></li>
                    <li><router-link v-bind:to="{name: 'Carousal'}">Carousel</router-link></li>
                    <li><router-link v-bind:to="{name: 'Dragable'}">Dragable & Swipe view</router-link></li>
                    <li><router-link v-bind:to="{name: 'Loadingspinner'}">Loading Spinner</router-link></li>
                </ul>
            </li>
            <li>
                <router-link v-bind:to="{name: 'Forms'}"><span class="fa-stack fa-lg pull-left"> <i class="fa fa-map-marker fa-stack-1x "></i></span>Forms</router-link>
            </li>
            <li>
                <label class="tree-toggle nav-header"><span class="fa-stack fa-lg pull-left"> <i class="fa fa-bell fa-stack-1x "></i></span>Tables <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                <ul class="nav nav-list tree">
                    <li><router-link v-bind:to="{name: 'Tables'}">Tables</router-link></li>
                    <li><router-link v-bind:to="{name: 'TablesSelect'}">Tables With Select</router-link></li>
                    <li><router-link v-bind:to="{name: 'SupportTicket'}">Support Ticket</router-link></li>
                    <li><router-link v-bind:to="{name: 'ContactAndEmployee'}">Contact And Employee</router-link></li>
                </ul>
            </li>
            <li>
                <label class="tree-toggle nav-header"><span class="fa-stack fa-lg pull-left"> <i class="fa fa-usd fa-stack-1x "></i></span>App <i class="fa fa-angle-down" aria-hidden="true"></i></label>
                <ul class="nav nav-list tree">
                    <li><router-link v-bind:to="{name: 'Calendar'}">Calendar</router-link></li>
                    <li><router-link v-bind:to="{name: 'ChatApp'}">Chat App</router-link></li>
                    <li><router-link v-bind:to="{name: 'Login'}">Login Page</router-link></li>
                    <!--<li><a href="/support-ticket">Support Ticket</a></li>
                    <li><a href="/contactandemployee">Contact/Employee</a></li>
                    <li><a href="/contact-grid">Contact Grid</a></li>-->
                </ul>
            </li>
        </ul>
    </div>
    <!-- Sidebar -->
</template>

<script>
    import Vue from 'vue';

    export default {
        name: 'Center',
        components: {

        },
        data() {
            return {
            }

        },
        beforeMount: function () {

        },
        mounted: function () {
            $("#menu-toggle").click(function (e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled");
            });
            $("#menu-toggle-2").click(function (e) {
                e.preventDefault();
                $(".app-sidebar-right").toggleClass("toggled-2");
                $('#menu ul').hide();
            });

            $('.tree-toggle').click(function () {
                $(this).parent().children('ul.tree').toggle(200);
            });

        },
        methods: {
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/backend/partials/sidebar.vue